import * as types from '../../mutation_type'
import { setCookie } from '../../../../../../util/util'
// import bus from '../../../../buses'
export default {
  [types.LOGINBYACCOUNT] (state, res) {
    state.userInfo = res.data.data
     setCookie('membercode', res.data.data.membercode)
     setCookie('username', res.data.data.username)
     setCookie('nickname', res.data.data.nickname)
     setCookie('memberid', res.data.data.memberid)
     setCookie('mlevelcode', res.data.data.mlevelcode)
     setCookie('mlevelname', res.data.data.mlevelname)
     setCookie('mdiscount', res.data.data.mdiscount)
     setCookie('imore', res.data.data.imore)
     setCookie('freticketnum', res.data.data.freticketnum)
     setCookie('openshare', res.data.data.openshare)
     setCookie('sex', res.data.data.sex)
     setCookie('mphone', res.data.data.mphone)
     setCookie('email', res.data.data.email)
     setCookie('cbalance', res.data.data.cbalance)
     setCookie('hpurl', res.data.data.hpurl)
     setCookie('birthday', res.data.data.birthday)
     setCookie('ibalance', res.data.data.ibalance)
     setCookie('emailcheck', res.data.data.emailcheck)
     setCookie('mphonecheck', res.data.data.mphonecheck)
  },
  [types.REGISTERBYACCOUNT] (state, res) {
    state.login_user = res.data
    state.checkErrorMessage = res.data.message
  },
  [types.GETCHECKCODETOREGISTER] (state, res) {
    if (res.data.status !== '001') {
      state.checkErrorMessage = res.data.message
    }
  },
  [types.LOGINORREGISTERINITBYWX] (state, res) {
    state.qcodeurl = res.data.QRurl
    state.uniqcode = res.data.unicode
  },
  [types.LOGINORREGISTERBYWX] (state, res) {
     if (res.data.data.membercode) {
      console.log(res)
      state.showWxLoginSuccess = true
      state.canIndexPush = true
      state.userInfo = res.data
       setCookie('username', res.data.data.username)
       setCookie('nickname', res.data.data.nickname)
       setCookie('memberid', res.data.data.memberid)
       setCookie('mlevelcode', res.data.data.mlevelcode)
       setCookie('mdiscount', res.data.data.mdiscount)
       setCookie('imore', res.data.data.imore)
       setCookie('freticketnum', res.data.data.freticketnum)
       setCookie('openshare', res.data.data.openshare)
       setCookie('sex', res.data.data.sex)
       setCookie('mphone', res.data.data.mphone)
       setCookie('email', res.data.data.email)
       setCookie('cbalance', res.data.data.cbalance)
       setCookie('hpurl', res.data.data.hpurl)
       setCookie('birthday', res.data.data.birthday)
       setCookie('ibalance', res.data.data.ibalance)
       setCookie('emailcheck', res.data.data.emailcheck)
       setCookie('mphonecheck', res.data.data.mphonecheck)
    }
  },
  [types.CHECKACCOUNTVAL] (state, res) {
    state.registering = res.data.data
    state.registerings = res.data.message
    setCookie('mphone', res.data.data.mphone)
    setCookie('email', res.data.data.email)
  },
  [types.GETMEMBERINFO] (state, res) {
    state.userInfo1 = res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/login/mutations/mutation.js